import { render, staticRenderFns } from "./Brandinfo.vue?vue&type=template&id=3e723aef&scoped=true"
import script from "./Brandinfo.vue?vue&type=script&lang=js"
export * from "./Brandinfo.vue?vue&type=script&lang=js"
import style0 from "./Brandinfo.vue?vue&type=style&index=0&id=3e723aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e723aef",
  null
  
)

export default component.exports